export default __webpack_public_path__ + "src/assets/disclaimer.846886eb2f76cf6b2459e3f853d9bd25.svg";